// src/i18n/en/fit.ts
// English counterpart of i18n/es/fit.ts — see there for context.
export const fit = {
  name: 'Product fit |||| Product fit',
  subtitle: 'Internal tool: step metrics cut by release and configuration',

  cuts: {
    appVersion: 'App version',
    flowConfigRef: 'Configuration reference',
    language: 'Language',
  },

  compare: {
    toggle: 'Compare before/after a deployment',
    before: 'Before',
    after: 'After',
  },

  list: {
    title: 'Indicators',
  },

  help: {
    title: 'Product fit',
    description:
      "The product fit tool (product C): the same step metrics as Operación, cut by app version, configuration and language, with a before/after view per deployment. Internal to Roommatik's product team only, never the hotel.",
    features: {
      cuts: 'The three cuts are free text: no catalogue of known versions or configurations exists yet for a property.',
      compare: 'Turn on comparison to see two periods and cuts side by side; this is not a computed diff — two independent calls to the same API.',
    },
    tips: {
      internal: "This page is internal: the product team uses it to decide on releases and configurations, not the hotel.",
    },
  },
};

export default fit;
